/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.config(['$locationProvider', '$modalProvider', function ($locationProvider, $modalProvider) {

        // HTML5 MODE url writing method (false: #/anchor/use, true: /html5/url/use)
        $locationProvider.html5Mode(false);
        //$locationProvider.hashPrefix(''); /* Back to default: fix ancore sulla stessa pagina */

        $modalProvider
            .when('loginModal', {
                title: 'Login modal',
                templateUrl: 'partials/login/modal',
                controller: 'AuthCtrl',
                customClass: 'modal-sm',
            }).when('userModal', {
                title: 'User modal',
                templateUrl: 'partials/user/modal',
                controller: 'UserCtrl',
            });

    }]);

}());